import {
  Box,
  IconButton,
  TextField,
  Typography,
  Table as TableUI,
  TableHead,
  TableRow,
  TableCell,
  Checkbox,
  TableFooter,
  Select,
  Pagination,
} from '@astro-ui/components'
import theme from '@astro-ui/theme'
import { ArrowRight, CloseCircle, Search } from '@astronautsid/wpe-icons'
import useTable from './useTable'
import Row from './Row'

const Table = () => {
  const {
    isAllChecked,
    isIndeterminate,
    checkedIds,
    query,
    locationSelected,
    soType,
    data,
    constants,
    search,
    handleSearch,
    handleChangeStatusNote,
    handleChangeProductType,
    handleChangeCheckbox,
    handleChangePage,
    handleChangeRowsPerPage,
  } = useTable()

  const renderLocation = () => (
    <Box display="flex" alignItems="center" gap="12px">
      <Box display="flex" alignItems="center" gap="8px">
        <Typography color="#646464">Asal</Typography>
        <Typography variant="headline-small" whiteSpace="nowrap">
          {locationSelected.origin}
        </Typography>
      </Box>

      <ArrowRight color="#646464" size={20} />

      <Box display="flex" alignItems="center" gap="8px">
        <Typography color="#646464">Tujuan</Typography>
        <Typography variant="headline-small" whiteSpace="nowrap">
          {locationSelected.destination}
        </Typography>
      </Box>
    </Box>
  )

  const renderSearch = () => (
    <TextField
      placeholder="Cari Nama Produk"
      value={search}
      onChange={(e) => {
        handleSearch(e.target.value)
      }}
      InputProps={{
        startAdornment: <Search />,
        endAdornment: search && (
          <IconButton onClick={() => handleSearch('')}>
            <CloseCircle size={18} />
          </IconButton>
        ),
      }}
      sx={{ width: '280px' }}
    />
  )

  return (
    <Box
      backgroundColor={theme.palette.background.paper}
      borderRadius={8}
      overflow="hidden"
      border={`1px solid ${theme.palette.divider}`}
      mt="24px"
      mb="80px"
      p="24px"
    >
      {soType === 'direct' && (
        <Box display="flex" justifyContent="space-between" alignItems="center" mb="16px" gap="16px">
          {renderSearch()}

          {renderLocation()}
        </Box>
      )}

      {soType === 'bad stock' && (
        <Box display="flex" flexDirection="column" gap="16px" mb="16px">
          <Box display="flex" justifyContent="flex-end" width="100%">
            {renderLocation()}
          </Box>
          <Box display="flex" justifyContent="space-between" gap="16px">
            {renderSearch()}

            <Box display="flex" gap="16px">
              <Select
                placeholder="Pilih Catatan"
                displayKey="name"
                options={constants.statusNotes}
                value={constants.statusNotes.find((note) => note.id === query.statusNoteId) || null}
                onChange={handleChangeStatusNote}
                sx={{ minWidth: '240px' }}
                withSearch
              />
              <Select
                required
                multiple
                multipleProps={{
                  valueType: 'total',
                  suffixTotal: 'Produk Tipe Terpilih',
                }}
                placeholder="Pilih Tipe Produk"
                displayKey="product_type_name"
                options={constants.productType}
                value={
                  constants.productType.filter((type) =>
                    query.productTypeIds?.split(',').includes(type.product_type_id.toString()),
                  ) || []
                }
                onChange={handleChangeProductType}
                sx={{ minWidth: '240px' }}
              />
            </Box>
          </Box>
        </Box>
      )}

      <TableUI
        tableContainerProps={{
          sx: {
            boxShadow: 'unset',
            borderRadius: '8px',
            borderLeft: '1px solid #E9E9E9',
            borderRight: '1px solid #E9E9E9',
          },
        }}
        tableHeaders={[]}
        TableHeaderComponent={
          <TableHead>
            <TableRow sx={{ backgroundColor: '#FAFAFA' }}>
              <TableCell textAlign="center">
                <Checkbox
                  checked={isAllChecked}
                  indeterminate={isIndeterminate}
                  onChange={(e) => handleChangeCheckbox(e.target.checked)}
                />
              </TableCell>
              <TableCell>
                <Typography variant="body-smallStrong">Nama Produk</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-smallStrong">Nomor SKU</Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-smallStrong">Tagging Bisnis</Typography>
              </TableCell>
              <TableCell textAlign="center">
                <Typography variant="body-smallStrong">Stok</Typography>
              </TableCell>
              <TableCell textAlign="center" backgroundColor="#FFF8E7">
                <Typography variant="body-smallStrong">Jumlah</Typography>
              </TableCell>
              <TableCell textAlign="center">
                <Typography variant="body-smallStrong">Status</Typography>
              </TableCell>
              <TableCell textAlign="center">
                <Typography variant="body-smallStrong">Catatan</Typography>
              </TableCell>
            </TableRow>
          </TableHead>
        }
        TableFooterComponent={
          <TableFooter>
            <TableRow>
              <TableCell colSpan={13}>
                <Box display="flex" justifyContent="space-between">
                  <Box display="flex" gap="8px" alignItems="center">
                    <Select
                      required
                      options={['10', '20', '30', '50']}
                      value={String(query.pageSize)}
                      onChange={(val) => {
                        handleChangeRowsPerPage(Number(val))
                      }}
                    />
                    <Typography variant="body3" fontWeight={700}>
                      Tiap Halaman
                    </Typography>
                  </Box>
                  <Pagination
                    pageIndex={query?.pageIndex || 1}
                    pageSize={query.pageSize || 20}
                    numberOfElements={data.length || 0}
                    onClick={handleChangePage}
                  />
                </Box>
              </TableCell>
            </TableRow>
          </TableFooter>
        }
      >
        {data.map((item) => (
          <Row
            key={item.productUniqueKey}
            item={item}
            checked={checkedIds.includes(item.productUniqueKey)}
          />
        ))}
      </TableUI>
    </Box>
  )
}

export default Table
